enum NavBarDisplayType {
    SECONDARY = 'secondary',
};

enum ScrollLevel {
    TOP = 0,
    MAIN = 1,
};

export {NavBarDisplayType, ScrollLevel};